export type RuntimeEnv = {
  NEXT_PUBLIC_MAGIC_API_KEY?: string;
  MAGIC_API_KEY?: string;
  POLYGON_RPC_URL?: string;
  NEXT_PUBLIC_WS_URL?: string;
  NEXT_PUBLIC_TURNSTILE_SITE_KEY?: string;
  POLY_BUILDER_CODE?: string;
};

declare global {
  interface Window {
    __RUNTIME_ENV__?: RuntimeEnv;
  }
}

let cachedRuntimeEnv: RuntimeEnv | null | undefined;

export const getRuntimeEnv = (): RuntimeEnv => {
  if (typeof window === "undefined") return {};
  if (window.__RUNTIME_ENV__) return window.__RUNTIME_ENV__;
  if (cachedRuntimeEnv !== undefined) return cachedRuntimeEnv ?? {};

  const template = document.getElementById("runtime-env");
  const serialized = template?.getAttribute("data-env");
  if (!serialized) {
    cachedRuntimeEnv = null;
    return {};
  }

  try {
    cachedRuntimeEnv = JSON.parse(serialized) as RuntimeEnv;
    window.__RUNTIME_ENV__ = cachedRuntimeEnv;
    return cachedRuntimeEnv;
  } catch (error) {
    cachedRuntimeEnv = null;
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to parse runtime env payload", error);
    }
    return {};
  }
};
